import React, { useEffect } from 'react';
import doLog from '@/common/log';

/**
 * 用于跨域打点，只进行iframe数据上报
 * @returns
 */
export default function log() {
  const parentLogListener = (message: { data: any }) => {
    const { data } = message;
    const { action, from, event } = data;
    if (from === 'quickView' && event === 'log' && action) {
      const params = JSON.parse(action);
      doLog(params.key, params.ext, params.type);
    }
  };
  useEffect(() => {
    // 监听父元素打点
    window.addEventListener('message', parentLogListener, false);
    return () => {
      window.removeEventListener('message', parentLogListener);
    };
  }, []);

  return null;
}
